import { useCallback, useMemo } from "react";
import { AggregationFunction, StatisticsDc } from "@evergis/api";

export const useStatisticsValues = (statisticsData?: StatisticsDc) => {
  const getStatisticsValueByType = useCallback(
    (type: AggregationFunction) => {
      return statisticsData?.statisticsResult.find(item => item.type === type)?.value ?? 0;
    },
    [statisticsData?.statisticsResult],
  );

  const min = useMemo(() => getStatisticsValueByType(AggregationFunction.Min), [statisticsData?.statisticsResult]);

  const max = useMemo(() => getStatisticsValueByType(AggregationFunction.Max), [statisticsData?.statisticsResult]);

  const sum = useMemo(() => getStatisticsValueByType(AggregationFunction.Sum), [statisticsData?.statisticsResult]);

  const count = useMemo(() => getStatisticsValueByType(AggregationFunction.Count), [statisticsData?.statisticsResult]);

  const totalCount = useMemo(() => getStatisticsValueByType(AggregationFunction.TotalCount), [statisticsData?.statisticsResult]);

  const distinctCount = useMemo(() => getStatisticsValueByType(AggregationFunction.DistinctCount), [statisticsData?.statisticsResult]);

  return {
    min,
    max,
    sum,
    count,
    totalCount,
    distinctCount,
  } as const;
};
